import {UNAUTH_USER, USER_DATA_SUCCESS, AUTH_USER} from '../actions/types';
import { localStorageAuthToken, localStorageIsChild, LS_EMAIL, localStorageProfileName, localStorageProfileId  } from '../constants'

const persist = store => next => action => {

    let result = next(action)
    switch (action.type){
        case AUTH_USER:
            localStorage.removeItem(localStorageAuthToken);
            let token = action.payload;
            localStorage.setItem(localStorageAuthToken, token);
            break;
        case UNAUTH_USER:
            localStorage.removeItem(localStorageAuthToken);
            localStorage.removeItem(localStorageIsChild);
            localStorage.removeItem(localStorageProfileName);
            localStorage.removeItem(localStorageProfileId);
            localStorage.removeItem(LS_EMAIL);
            break;
        case USER_DATA_SUCCESS:
            let email = store.getState().userData.new_email;
            if(localStorage.getItem(LS_EMAIL) !== email){
                localStorage.setItem(LS_EMAIL, email)
            }
            break;
        default:
            break;
    }
    return result
}
 export default persist
